/*
 * Mobile-only smart-collapse for the header search bar.
 *
 * When the "Collapse search bar on scroll (mobile only)" header setting is
 * enabled, this shim toggles .header__search--collapsed on the search row
 * based on scroll direction on screens ≤ 699px. The rest of the header is
 * left alone. Desktop is untouched.
 */
(function () {
  var MOBILE_MQ = window.matchMedia('(max-width: 699px)');
  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');
  var HIDE_THRESHOLD = 100;
  var SHOW_THRESHOLD = 10;
  var COLLAPSED_CLASS = 'header__search--collapsed';

  var target = null;
  var lastScrollTop = 0;
  var accumulatedDown = 0;
  var accumulatedUp = 0;
  var ticking = false;

  function isActive() {
    return MOBILE_MQ.matches && !REDUCED_MOTION.matches;
  }

  function collapse() {
    if (target && !target.classList.contains(COLLAPSED_CLASS)) {
      target.classList.add(COLLAPSED_CLASS);
    }
  }

  function expand() {
    if (target && target.classList.contains(COLLAPSED_CLASS)) {
      target.classList.remove(COLLAPSED_CLASS);
    }
    accumulatedDown = 0;
    accumulatedUp = 0;
  }

  function onScroll() {
    if (!isActive() || !target) return;
    var y = window.scrollY;
    if (y < 0) return;
    if (y < lastScrollTop) {
      accumulatedUp += (lastScrollTop - y);
      accumulatedDown = 0;
      if (accumulatedUp > SHOW_THRESHOLD) expand();
    } else if (y > lastScrollTop) {
      accumulatedDown += (y - lastScrollTop);
      accumulatedUp = 0;
      if (accumulatedDown > HIDE_THRESHOLD) collapse();
    }
    lastScrollTop = y;
  }

  function onScrollThrottled() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      onScroll();
      ticking = false;
    });
  }

  function onViewportChange(event) {
    if (!event.matches) expand();
  }

  function init() {
    target = document.querySelector('.header__search');
    if (!target) return;
    lastScrollTop = window.scrollY;
    window.addEventListener('scroll', onScrollThrottled, { passive: true });
    if (typeof MOBILE_MQ.addEventListener === 'function') {
      MOBILE_MQ.addEventListener('change', onViewportChange);
    } else if (typeof MOBILE_MQ.addListener === 'function') {
      MOBILE_MQ.addListener(onViewportChange);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
